import * as React from 'react'
import { Button } from 'reactstrap'
import './SaveBar.scss'

interface IComponentProps {
  onSaveClick: () => void
  onCancelClick: () => void
  saveDisabled: boolean
}

export default class SaveBar extends React.PureComponent<IComponentProps> {
  public render() {
    return (
      <div className='save-bar d-flex flex-row'>
        <div className='mr-2 ml-auto align-self-center'>
          <Button className='text-light' onClick={this.props.onCancelClick}>
            Cancel
          </Button>
        </div>
        <div className='mr-4 align-self-center'>
          <Button
            color='primary'
            disabled={this.props.saveDisabled}
            onClick={this.props.onSaveClick}
          >
            Save
          </Button>
        </div>
      </div>
    )
  }
}
